import {
    setLoadingState,
    resetButtonState,
    setupInfiniteScroll,
} from "../../utils/common.js";
import "select2";

export function initVehicleFilters() {
    // Toggle Filter Drawer
    $("#btnFilter").on("click", function () {
        $("#filtersDrawer").addClass("open");
        $("#filtersDrawerBackdrop").addClass("show");
        $("body").addClass("overflow-hidden");
    });

    $(".btn-close-filters, #filtersDrawerBackdrop").on("click", function () {
        $("#filtersDrawer").removeClass("open");
        $("#filtersDrawerBackdrop").removeClass("show");
        $("body").removeClass("overflow-hidden");
    });

    // Initialize Select2
    $("#placaFilter").select2({
        placeholder: "Selecione a placa",
        allowClear: true,
        width: "100%",
        ajax: {
            url: "/veiculos/getVehicles",
            type: "POST",
            dataType: "json",
            delay: 250,
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
            },
            data: function (params) {
                return {
                    value: params.term,
                };
            },
            processResults: function (data) {
                const base = Array.isArray(data?.results) ? data.results : [];
                return {
                    results: base.map(function (item) {
                        return {
                            id: item.placa,
                            text: item.placa,
                        };
                    }),
                };
            },
            cache: true,
        },
    });

    // Load Brands
    function loadBrands(type) {
        // Ensure type defaults to 'all' if empty or null
        const safeType = type || "all";
        $.get(`/veiculos/get-brands?type=${safeType}`, function (data) {
            const select = $("#marcaFilter");
            select.empty().append('<option value="">Todas</option>');
            (Array.isArray(data?.results) ? data.results : []).forEach(
                function (item) {
                    select.append(new Option(item.text, item.id));
                }
            );
        });
    }

    // Load Models
    function loadModels(brandId) {
        const select = $("#modeloFilter");
        const type = $("#filterTipoVeiculo").val();
        select.prop("disabled", true); // Temporarily disable while loading
        $.get(
            `/veiculos/get-models?brand_id=${brandId || ""}&type=${type || "all"
            }`,
            function (data) {
                select.empty().append('<option value="">Todos</option>');
                (Array.isArray(data?.results) ? data.results : []).forEach(
                    function (item) {
                        select.append(new Option(item.text, item.id));
                    }
                );
                select.prop("disabled", false);
            }
        );
    }

    // Load Colors
    function loadColors() {
        $.get("/veiculos/get-colors", function (data) {
            const select = $("#corFilter");
            select.empty().append('<option value="">Todas</option>');
            data.results.forEach(function (item) {
                select.append(new Option(item.text, item.id));
            });
        });
    }

    // Initial Load
    loadBrands("all"); // Load all brands by default
    loadModels(""); // Load all models by default
    loadColors();

    // Event Listeners
    $("#filterTipoVeiculo").on("change", function () {
        const type = $(this).val();
        loadBrands(type);
        $("#marcaFilter").val("").trigger("change");
        // When type changes, brand resets to empty ("Todas"), which triggers change, which calls loadModels('')
        // So we don't need to manually call loadModels or disable it here.
    });

    $("#marcaFilter").on("change", function () {
        loadModels($(this).val());
    });

    // Apply Filters
    function applyFilters() {
        $(document).trigger("search:refresh");

        const filters = {
            tipo_veiculo: $("#filterTipoVeiculo").val(),
            placa: $("#placaFilter").val(),
            marca: $("#marcaFilter").val(),
            modelo: $("#modeloFilter").val(),
            cor: $("#corFilter").val(),
        };

        // Count active filters
        let activeCount = 0;
        // Check if value is not 'all' (default) and not empty
        if (filters.tipo_veiculo && filters.tipo_veiculo !== 'all') activeCount++;
        if (filters.placa && filters.placa.length > 0) activeCount++;
        if (filters.marca) activeCount++;
        if (filters.modelo) activeCount++;
        if (filters.cor) activeCount++;

        console.log('Vehicle Active Count:', activeCount); // Debug log
        const $badge = $("#filterCount");
        if ($badge.length) {
            if (activeCount > 0) {
                $badge.text(activeCount).removeClass("d-none");
            } else {
                $badge.text("0").addClass("d-none");
            }
        }

        // Close drawer if open
        if ($("#filtersDrawer").hasClass("open")) {
            $(".btn-close-filters").trigger("click");
        }
    }

    $("#btnApplyFilters").on("click", applyFilters);

    // Clear All Filters
    $("#btnClearAllFilters").on("click", function () {
        const form = $("#vehiclesFiltersForm");
        if (form.length > 0) form[0].reset();

        $("#placaFilter").val(null).trigger("change");
        $("#filterTipoVeiculo").trigger("change"); // Reset dependent dropdowns
        $("#filterCount").text("0").addClass("d-none");
        console.log('Vehicle Filters Cleared'); // Debug log
        applyFilters();
    });

    // Clear filters from No Data state
    $(document).on("click", "#btnClearFiltersNoData", function () {
        $("#btnClearAllFilters").trigger("click");
    });

    // Order By Change
    $(".js-sort-option").on("click", function (e) {
        e.preventDefault();

        // Remove active class from all options and add to clicked one
        $(".js-sort-option").removeClass("active");
        $(this).addClass("active");

        // Update hidden input value
        const value = $(this).data("value");
        $("#orderBySelect").val(value);

        applyFilters();
    });

    // Selection Logic
    let selectedIds = [];

    function updateSelectionToolbar() {
        const selectedCount = selectedIds.length;
        $("#selectedCount").text(selectedCount);

        if (selectedCount > 0) {
            $("#selectionToolbar").removeClass("d-none");
        } else {
            $("#selectionToolbar").addClass("d-none");
        }
    }

    $(document).on("change", "#selectAllVehicles", function () {
        const isChecked = $(this).is(":checked");
        $(".vehicle-checkbox").prop("checked", isChecked);

        selectedIds = [];
        if (isChecked) {
            $(".vehicle-checkbox").each(function () {
                selectedIds.push($(this).val());
            });
        }
        updateSelectionToolbar();
    });

    $(document).on("change", ".vehicle-checkbox", function () {
        const id = $(this).val();
        if ($(this).is(":checked")) {
            if (!selectedIds.includes(id)) {
                selectedIds.push(id);
            }
        } else {
            selectedIds = selectedIds.filter((item) => item !== id);
            $("#selectAllVehicles").prop("checked", false);
        }
        updateSelectionToolbar();
    });

    $("#clearSelectionLink").on("click", function (e) {
        e.preventDefault();
        selectedIds = [];
        $(".vehicle-checkbox").prop("checked", false);
        $("#selectAllVehicles").prop("checked", false);
        updateSelectionToolbar();
    });

    $("#btnSelectAll").on("click", function () {
        const checkbox = $("#selectAllVehicles");
        checkbox.prop("checked", !checkbox.is(":checked")).trigger("change");
    });

    // Export Logic
    $("#exportSelectedXls").on("click", function (e) {
        e.preventDefault();

        if (selectedIds.length === 0) {
            const message = "Selecione pelo menos um veículo.";

            if (
                window.bootstrap &&
                typeof window.bootstrap.Modal !== "undefined"
            ) {
                let modalEl = document.getElementById("errorModal");
                if (!modalEl) {
                    modalEl = document.createElement("div");
                    modalEl.id = "errorModal";
                    modalEl.className = "modal fade";
                    modalEl.setAttribute("tabindex", "-1");
                    modalEl.setAttribute("aria-modal", "true");
                    modalEl.setAttribute("role", "dialog");
                    modalEl.innerHTML = `
                        <div class="modal-dialog modal-dialog-centered">
                            <div class="modal-content">
                                <div class="modal-body text-center">
                                    <span class="icon-bg-lg m-auto mb-3"><i class="sg sg-smiley-x-eyes"></i></span>
                                    <div id="errorModalMessages" class="mb-3"></div>
                                    <div class="text-center d-flex justify-content-center">
                                        <button type="button" class="btn btn-primary" data-bs-dismiss="modal">Fechar</button>
                                    </div>
                                </div>
                            </div>
                        </div>`;
                    document.body.appendChild(modalEl);
                }

                const messagesEl = modalEl.querySelector("#errorModalMessages");
                if (messagesEl) {
                    messagesEl.innerHTML = `<p class="mb-0">${message}</p>`;
                }

                const modal = new window.bootstrap.Modal(modalEl, {
                    backdrop: "static",
                    keyboard: false,
                });
                modal.show();
                return;
            }
            alert(message);
            return;
        }

        const filters = {
            tipo_veiculo: $("#tipoVeiculo").val(),
            placa: $("#placaFilter").val(),
            marca: $("#marcaFilter").val(),
            modelo: $("#modeloFilter").val(),
            cor: $("#corFilter").val(),
            order_by: $("#orderBySelect").val(),
            selected_ids: selectedIds.join(","),
        };

        const queryString = new URLSearchParams(filters).toString();
        window.location.href = `/veiculos/export?${queryString}`;
    });
}
